import request from '@/utils/request'

// 生存环境


// 获取快速认领接口
export function expertCheck (data) {
  return request({
    data: data,
    url: '/expert_check',
    method: 'post'
  })
}
// process.env.NODE_ENV == 'production'?'http://kid.ckcest.cn/expert_check':
export function expertCheckNew (data) {
  return request({
    data: data,
    url: '/expert_check',
    method: 'post'
  })
}




// 获取用户信息
export function getUser (data) {
  return request({
    data: data,
    url: '/old/api/User/ById',
    method: 'post'
  })
}
// 获取用户信息
export function getBase64Avatar (data) {
  return request({
    data: data,
    url: '/old/getBase64Avatar',
    method: 'post'
  })
}

// 获取城市
export function getCity (data) {
  return request({
    url: '/old/api/Area/Query',
    data: data,
    method: 'post'
  })
}
// 保存用户信息
export function saveUser (data) {
  return request({
    url: '/old/api/User/Update',
    data: data,
    method: 'post'
  })
}

// 获取关注专家
export function getExp (data) {
  return request({
    url: '/old/api/UserExpertFocused/Query',
    data: data,
    method: 'post'
  })
}

// 删除关注专家
export function delFocus (data) {
  return request({
    url: '/old/api/UserFocused/BatchDelete',
    data: data,
    method: 'post'
  })
}

// 获取授权管理专家列表
export function getAuthorizationExp (data) {
  return request({
    url: '/old/api/UserExpertManagement/Query',
    data: data,
    method: 'post'
  })
}

// 新增授权管理专家
export function addExp (data) {
  return request({
    url: '/old/api/UserExpertManagement/Insert',
    data: data,
    method: 'post'
  })
}
// 获取授权机构
export function getOrg (data) {
  return request({
    data: data,
    url: '/old/api/UserOrganizationExpert/Query',
    method: 'post'
  })
}

// 修改授权权限
export function editExpAut (data) {
  return request({
    data: data,
    url: '/old/api/UserExpertManagement/Update',
    method: 'post'
  })
}

// 取消授权
export function delExpAut (data) {
  return request({
    data: data,
    url: '/old/api/UserExpertManagement/Delete',
    method: 'post'
  })
}

// 确认用户具有专家权限
export function confirmPer (data) {
  return request({
    data: data,
    url: '/old/api/expertmanagementcheck',
    method: 'post'
  })
}

// 获取用户日记
export function getLog (data) {
  return request({
    data: data,
    url: '/old/api/Log/Query',
    method: 'post'
  })
}

// 发送邮件
export function sendEmail (data) {
  return request({
    data: data,
    url: '/old/api/mail',
    method: 'post'
  })
}

// 手机验证码
export function getCode (data) {
  return request({
    data: data,
    url: '/old/api/autosms',
    method: 'post'
  })
}
// 开发环境

// // 获取用户信息
// export function getUser () {
//   return request({
//     url: 'api/api/User/ById',
//     method: 'get'
//   })
// }

// // 获取城市
// export function getCity (data) {
//   return request({
//     url: 'api/api/Area/Query',
//     data: data,
//     method: 'post'
//   })
// }

// // 保存用户信息
// export function saveUser (data) {
//   return request({
//     url: 'api/api/User/Update',
//     data: data,
//     method: 'post'
//   })
// }

// // 获取关注专家
// export function getExp (data) {
//   return request({
//     url: '/api/api/UserExpertFocused/Query',
//     data: data,
//     method: 'post'
//   })
// }

// // 删除关注专家
// export function delFocus (data) {
//   return request({
//     url: '/api/api/UserFocused/BatchDelete',
//     data: data,
//     method: 'post'
//   })
// }

// // 获取授权管理专家列表
// export function getAuthorizationExp (data) {
//   return request({
//     url: '/api/api/UserExpertManagement/Query',
//     data: data,
//     method: 'post'
//   })
// }

// // 获取授权机构
// export function getOrg (data) {
//   return request({
//     data: data,
//     url: '/api/api/UserOrganizationExpert/Query',
//     method: 'post'
//   })
// }

// // 修改授权权限
// export function editExpAut (data) {
//   return request({
//     data: data,
//     url: '/api/api/UserExpertManagement/Update',
//     method: 'post'
//   })
// }

// // 取消授权
// export function delExpAut (data) {
//   return request({
//     data: data,
//     url: '/api/api/UserExpertManagement/Delete',
//     method: 'post'
//   })
// }
// // 确认用户具有专家权限
// export function confirmPer (data) {
//   return request({
//     data: data,
//     url: '/api/api/expertmanagementcheck',
//     method: 'post'
//   })
// }
// // 获取用户日记
// export function getLog (data) {
//   return request({
//     data: data,
//     url: '/api/api/Log/Query',
//     method: 'post'
//   })
// }

// // 发送邮件
// export function sendEmail (data) {
//   return request({
//     data: data,
//     url: '/api/api/mail',
//     method: 'post'
//   })
// }
// export function addExp (data) {
//   return request({
//     url: '/api/api/UserExpertManagement/Insert',
//     data: data,
//     method: 'post'
//   })
// }
// // 手机验证码
// export function getCode (data) {
//   return request({
//     data: data,
//     url: '/api/api/autosms',
//     method: 'post'
//   })
// }



// WEBPACK FOOTER //
// ./src/api/center.js